module.exports = __webpack_public_path__ + "static/media/desktop_partner_landing_pnb.03f211b7.svg";